import { ref } from 'vue';
import { ChargebeeInstance, Chargebee } from '@/services/chargebee/types';
import { Task } from 'fp-ts/Task';

export const chargebee = ref<ChargebeeInstance | null>(null);

export const getChargeBeeInstance: Task<ChargebeeInstance | null> = async (): Promise<ChargebeeInstance | null> => {
  if (!chargebee.value) {
    await initChargeBee();
  }

  return chargebee.value;
};

const initChargeBee = async () => {
  await Chargebee.init({
    site: process.env.VUE_APP_CHARGEBEE_SITE || '',
    publishableKey: process.env.VUE_APP_CHARGEBEE_PUBLISHABLE_KEY || '',
    enableGTMTracking: true,
  });

  chargebee.value = Chargebee.getInstance();
};
